"use strict";import{tag as o}from"../custom-tag.js";export function instructorCommunicationIcon({height:t=16,width:r=16,hidden:a=!1,title:i="Instructor communication"}={}){return o`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${a?"true":"false"}"
      role="img"
      aria-label="${i}"
    >
      <mask
        id="instructor-communication_svg__mask0_6875_6154"
        width="20"
        height="18"
        x="2"
        y="3"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M13.025 4.549c0-.58.47-1.049 1.05-1.049h6.876c.58 0 1.049.47 1.049 1.049v4.507c0 .579-.47 1.048-1.049 1.048h-3.533c-.208 0-.412.062-.585.179l-1.68 1.13a.524.524 0 0 1-.816-.435v-.218a.656.656 0 0 0-.656-.656.656.656 0 0 1-.656-.656zm-3.44 9.977a4.3 4.3 0 0 1-2.742.962 4.3 4.3 0 0 1-2.057-.515c-.413-.225-.933-.272-1.273.052A4.88 4.88 0 0 0 2 18.551v1.283c0 .467.38.846.846.846h8.052c.467 0 .846-.38.846-.846v-1.283a4.87 4.87 0 0 0-1.43-3.442 13 13 0 0 0-.729-.583M7 14.013c1.754 0 3.205-1.37 3.205-3.092 0-1.72-1.451-3.062-3.205-3.062s-3.205 1.37-3.205 3.092c0 1.72 1.451 3.062 3.205 3.062"
        />
      </mask>
      <g mask="url(#instructor-communication_svg__mask0_6875_6154)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=instructorCommunication.js.map
